<template>
  <milestone-wrapper :subscription-period-id="subscriptionPeriodId" :data="data" :meta="meta">
    <template slot="content-completed">
      <GridTable v-if="data.content && data.content.length" :columns="columns" :rows="data.content" class="col-12">
        <template #row="{row}">
          <GridTableCell>{{ row.description }}</GridTableCell>
          <GridTableCell class="text-center">{{ row.currency }}</GridTableCell>
          <GridTableCell class="text-right">{{ formatPrice(row.list_price) }}</GridTableCell>
          <GridTableCell class="text-right">{{ formatPrice(row.first_offer_price) }}</GridTableCell>
          <GridTableCell class="text-right">{{ formatPrice(row.price) }}</GridTableCell>
        </template>
      </GridTable>
    </template>
  </milestone-wrapper>
</template>

<script>
import MilestoneMixin from '@/mixins/milestone.mixin'
// Components
import MilestoneWrapper from '@/components/milestones/MilestoneWrapper'
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

export default {
  name: 'MilestonePriceEntries',
  components: { MilestoneWrapper, GridTable, GridTableCell },
  mixins: [MilestoneMixin],
  props: {
    data: {
      type: Object,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    subscriptionPeriodId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      email: null
    }
  },

  computed: {
    columns() {
      return [
        { label: 'Description', width: '2fr', align: 'center' },
        { label: 'Currency', width: '1fr', align: 'center' },
        { label: 'List price', width: '1fr', align: 'right' },
        { label: 'First offer', width: '1fr', align: 'right' },
        { label: 'Final offer', width: '1fr', align: 'right' }
      ]
    }
  }
}
</script>
